export const MORE_INFO = 'MoreInfoPage';
export const DOCUMENTS_REQUIRED = 'DocumentsReqPage';
export const CONFIRMATION = 'ConfirmationPage';
export const FINAL_SUBMIT_ERROR = 'FinalSubmitErrorPage';
